import { render, staticRenderFns } from "./sipm-view.vue?vue&type=template&id=58b4bd63&"
import script from "./sipm-view.vue?vue&type=script&lang=js&"
export * from "./sipm-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports